/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Group_Description_LabelInputs */



/**
* | output |
* | --- |
* | "Description" |
*
* @param {Team_Manager_Group_Description_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_group_description_label = /** @type {((inputs?: Team_Manager_Group_Description_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Group_Description_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description")
	if (locale === "de") return /** @type {LocalizedString} */ ("Beschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Описание")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("説明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição")
	return /** @type {LocalizedString} */ ("Description")
});